<nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" [tabPanel]="tabPanel">
  <a
    mat-tab-link
    queryParamsHandling="merge"
    [routerLink]="[MARKET_CAP_PATH]"
    routerLinkActive
    #winRates="routerLinkActive"
    [active]="winRates.isActive"
  >
    {{ 'performance.marketCap' | translate }}
  </a>
  <a
    mat-tab-link
    queryParamsHandling="merge"
    [routerLink]="[SECTOR_PATH]"
    routerLinkActive
    #errorRates="routerLinkActive"
    [active]="errorRates.isActive"
  >
    {{ 'performance.sector' | translate }}
  </a>
  <a
    mat-tab-link
    queryParamsHandling="merge"
    [routerLink]="[ANALYST_COVERAGE_PATH]"
    routerLinkActive
    #analystCoverage="routerLinkActive"
    [active]="analystCoverage.isActive"
  >
    {{ 'performance.analystCoverage' | translate }}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
